import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from '../../base/avatar/components/Avatar';
import Icon from '../../base/icons/components/Icon';
import { IconPin, IconPinned, IconSharing } from '../../base/icons/svg';
export function isSharing(list, id) {
    if (list?.length) {
        const index = list.findIndex((p) => p === id);
        return Boolean(index + 1);
    }
    return false;
}
const ParticipantDisplay = ({ participant, setTmpPinId, _sortedRemoteScreenshares, tmpPinned = false }) => {
    const { t } = useTranslation();
    const isScreenShare = participant?.fakeParticipant;
    const handlePariticipantIdOrScreenShareId = (id) => {
        if (isScreenShare) {
            let participantId = id.split('-')[0];
            return participantId;
        }
        else
            return id;
    };
    return (React.createElement("div", { className: 'participant-display', onClick: () => setTmpPinId(participant?.id) },
        React.createElement("div", { className: 'participant-info-box' },
            React.createElement(Avatar, { participantId: handlePariticipantIdOrScreenShareId(participant?.id), className: "avatar-menu-controller" }),
            React.createElement("div", { className: 'participant-info' },
                React.createElement(Typography, { className: 'participant-name' },
                    participant?.name,
                    " ",
                    participant?.local && ' (' + t('chat.you') + ')'),
                React.createElement(Typography, { className: 'participant-role' }, participant?.fakeParticipant ? t('menuController.screenShare', { who: participant?.name }) : t('menuController.' + participant?.role)))),
        React.createElement("div", { className: 'icon-state-container' },
            isSharing(_sortedRemoteScreenshares, participant?.id) && React.createElement(Icon, { color: '#44494D', src: IconSharing, size: 22 }),
            participant?.pinned || tmpPinned ?
                React.createElement(Icon, { src: IconPinned, size: 22 }) :
                React.createElement(Icon, { src: IconPin, size: 22 }))));
};
export default ParticipantDisplay;
